import { MenuScreen } from 'features/generator/qrTypes/Menu/MenuScreen'
import { ReactNode } from 'react'

import { QR_TYPE } from '../../generatorTypes'
import { TQrScreenProps } from '../../QrScreen/QrScreen'
import {
	AppScreen,
	BusinessPageScreen,
	FacebookScreen,
	PdfScreen,
	PlainTextScreen,
	SocialMediaScreen,
	VCardScreen,
	VideoScreen,
	WebsiteUrlScreen,
	WifiScreen,
} from '../../qrTypes'
import { ImagesScreen } from '../../qrTypes/Images/ImagesScreen/ImagesScreen'

export const QR_TYPE_TO_CONTENT_SCREEN: Record<
	QR_TYPE,
	(props: TQrScreenProps) => ReactNode
> = {
	[QR_TYPE.Url]: WebsiteUrlScreen,
	[QR_TYPE.VCard]: VCardScreen,
	[QR_TYPE.Pdf]: PdfScreen,
	[QR_TYPE.Images]: ImagesScreen,
	[QR_TYPE.SocialMedia]: SocialMediaScreen,
	[QR_TYPE.Video]: VideoScreen,
	[QR_TYPE.PlainText]: PlainTextScreen,
	[QR_TYPE.BusinessPage]: BusinessPageScreen,
	[QR_TYPE.Facebook]: FacebookScreen,
	[QR_TYPE.Wifi]: WifiScreen,
	[QR_TYPE.App]: AppScreen,
	[QR_TYPE.Menu]: MenuScreen,
}
